import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=5cccfd50&scoped=true&"
import script from "./Form.vue?vue&type=script&setup=true&lang=js&"
export * from "./Form.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=5cccfd50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cccfd50",
  null
  
)

export default component.exports